import { Suspense, lazy } from "react";
import Loader from "../../customs/loader/main";


const Main = lazy (
  () => import("../../components/reports/electionResultsReport/main")
);

const ElectionSetup = () => {
  return (
    // <Layout>
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default ElectionSetup;
